<template>
    <el-dialog
            class="popup"
            :width="windowWidth > 1200 ? '1170px' : '95%'"
            :append-to-body="true"
            :show-close="false"
            :visible="showComment">
        <button class="btn popup__close" @click.prevent="closeComment">
            <i class="el-icon-close"></i>
        </button>
        <span class="comments__name">
                    {{ fullComment.name }} <span class="comments__city" v-if="fullComment.city">{{ fullComment.city }}</span>
                </span>
        <span class="comments__quote">“</span>
        <div class="comments__text">
            {{ fullComment.description }}
        </div>
    </el-dialog>
</template>

<script>
    import {mapActions, mapState} from 'vuex';
    import {store} from "../../../store/comments";

    export default {
        name: "FullComment",
        store,
        computed: {
            ...mapState([
                'fullComment',
                'showComment'
            ]),
        },
        methods: {
            ...mapActions([
                'closeComment',
            ]),
        },
    }
</script>